import * as types from '../../actions/actionTypes';
import SqftStore from "../../bvcomponents/sqft/components/canvas/store/sqftStore";
export const ACTIVE_ROOM_TYPE = {
  category: 'category',
  roomGroup: 'roomGroup',
  quote: 'quote',
}

const initialState = {
  menuOpened: "",
  menuOpenedLock: false,
  activeButton: null,
  activeSubMenuButton: null,
  activeLevel3Button: null,
  activeRoom: null,
  activeRoomId: null,
  activeRoomIndex: null,
  activeRoomType: null,
  sqftActiveShapeId: null,
  isFreeDrawMode: false,
  isWallsUpMode: true,
  isWallsLockMode: true,
  roomSwitcher: {
    isVisible: false
  },
  roomLayouts: [],
  contextMenu: {
    isOpened: false,
    activeMenu: "",
    pos: {},
    parent: null
  },
  contextMenuV2: {
    isOpened: false,
    menuItems: [],
    position: {}
  },
  systemMessage: {
    isOpened: false,
    title: "",
    content: null,
    large: false
  },
  ar3dPopup: {
    isOpened: false,
    contentType: false
  },
  systemDeleteMessage: {
    isOpened: false,
    shape: null
  },
  sqftPopup: {
    title: "",
    content: "",
    isOpened: false,
    additionalClasses: "",
    confirmCallback: new Function (),
    confirmText: "",
    cancelCallback: new Function (),
    cancelText: ""
  },
  changeValuePopups: [],
  validationPopups: [],
  shapeIdsWithMissingFeature: [],
  isShapeFeatureMissing: false,
  isITextEditing: false,
  isSlabPlaceholderOverlapsWithMultipleShapes: false,
  validationMessage: {},
  reCacheMenuCounter: 0,
  cabinetRelatedItems: [],
  featurePicker: {
    isOpen: false,
    isAdding: false,
    partIds: [],
    shapeId: '',
    type: '',
  },
  selectedFeatureInPicker: null,
  clearCacheTick: 0,
};

export default function (state = initialState, action) {
  let changeValuePopups;
  let validationPopups;
  switch (action.type) {
    case types.SET_SQFT_MENU_OPENED:
    case types.SET_SQFT_MENU_LOCK:
    case types.SET_SQFT_MENU_ACTIVE_BUTTON:
    case types.SET_SQFT_ACTIVE_SUB_MENU_BUTTON:
    case types.SET_SQFT_ACTIVE_LEVEL3_BUTTON:
    case types.SET_SQFT_ACTIVE_ROOM:
    case types.SET_SQFT_ACTIVE_ROOM_ID:
    case types.SET_SQFT_ROOM_LAYOUTS:
    case types.SET_SQFT_ACTIVE_ROOM_TYPE:
    case types.SET_SQFT_ACTIVE_ROOM_INDEX:
    case types.SET_FREE_DRAW_MODE:
    case types.SET_WALLS_UP_MODE:
    case types.SET_WALLS_LOCK_MODE:
    case types.SET_SHAPE_IDS_WITH_MISSING_FEATURES:
    case types.SET_CHANGE_SHAPE_FEATURE_MISSING_MESSAGE:
    case types.SET_IS_ITEXT_EDITING:
    case types.SET_SLAB_PLACEHOLDER_OVERLAPS_WITH_MULTIPLE_SHAPES:
    case types.SET_RE_CACHE_MENU_COUNTER:
    case types.SET_SQFT_ACTIVE_SHAPE_ID:
    case types.SET_SELECTED_FEATURE_IN_PICKER:
    // case types.SET_CABINET_RELATED_ITEMS:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.FEATURES_REFRESH_TICK:
      SqftStore.edgeFeatures = [];
      return { ...state, clearCacheTick: state.clearCacheTick + 1 };
    case types.ADD_SHAPE_ID_WITH_MISSING_FEATURES:
      return Object.assign({}, state, {
        shapeIdsWithMissingFeature: [...state.shapeIdsWithMissingFeature, action.payload]
      });
    case types.SET_SQFT_ROOM_SWITCHER_VISIBLE:
      return Object.assign({}, state, {
        roomSwitcher: {...state.roomSwitcher, ...{isVisible: action.payload.isVisible}}
      });
    case types.SET_SQFT_CONTEXT_MENU:
      return Object.assign({}, state, {
        contextMenu: {...state.contextMenu, ...action.payload.contextMenu}
      });
    case types.SET_SQFT_SYSTEM_MESSAGE:
      return Object.assign({}, state, {
        systemMessage: {...state.systemMessage, ...action.payload.systemMessage}
      });
    case types.SET_SQFT_AR3D_POPUP:
      return Object.assign({}, state, {
        ar3dPopup: {...state.ar3dPopup, ...action.payload.ar3dPopup}
      });
    case types.SET_SQFT_POPUP:
      return Object.assign({}, state, {
        sqftPopup: {...state.sqftPopup, ...action.payload.sqftPopup}
      });
    case types.SET_FEATURE_PICKER:
      return Object.assign({}, state, {
        featurePicker: {...state.featurePicker, ...action.payload.featurePicker}
      });
    case types.SET_SQFT_CONTEXT_MENU_V2:
      return Object.assign({}, state, {
        contextMenuV2: {...state.contextMenuV2, ...action.payload.contextMenuV2}
      });
    case types.SET_SQFT_SYSTEM_DELETE_MESSAGE:
      return Object.assign({}, state, {
        systemDeleteMessage: {...state.systemDeleteMessage, ...action.payload.systemDeleteMessage}
      });

    case types.SET_CHANGE_VALUE_POPUPS:
      state = {...state, changeValuePopups: action.payload.changeValuePopups};
      break;
    case types.ADD_CHANGE_VALUE_POPUP:
      return Object.assign({}, state, {
        changeValuePopups: [...state.changeValuePopups, action.payload]
      });
    case types.CHANGE_VALUE_POPUP:
      changeValuePopups = state.changeValuePopups.map((item) => {
        if (item.id !== action.payload.id) { return item }

        return {
          ...item,
          ...action.payload
        }
      })
      return Object.assign({}, state, {changeValuePopups: changeValuePopups });
    case types.DELETE_CHANGE_VALUE_POPUP:
      changeValuePopups = state.changeValuePopups.filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {
        changeValuePopups: changeValuePopups
      });

    case types.SET_VALIDATION_POPUPS:
      state = {...state, validationPopups: action.payload.validationPopups};
      break;
    case types.ADD_VALIDATION_POPUP:
      return Object.assign({}, state, {
        validationPopups: [...state.validationPopups, action.payload]
      });
    case types.VALIDATION_POPUP:
      validationPopups = state.validationPopups.map((item) => {
        if (item.id !== action.payload.id) { return item }

        return {
          ...item,
          ...action.payload
        }
      })
      return Object.assign({}, state, {validationPopups: validationPopups });
    case types.DELETE_VALIDATION_POPUP:
      validationPopups = state.validationPopups.filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {
        validationPopups: validationPopups
      });
    default:
      return state
  }
}
